export function isNullOrUndefined(val: any): boolean {
	return (window as any).isNullOrUndefined(val);
}

export async function saveManyForm(form: Array<any>): Promise<boolean> {
	await fetch("form/SaveManyForm", {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		cache: "no-cache",
		body: JSON.stringify(form),
	}).then(x => x.json())
		.then(x => {
			if (x.isError) {
				alert("There was an error during save: \n\n" + x.messages.join(","));
			}
		});
	return false;
}

export function createForm(mode: string, keyValue: string, dataTable: string) {
	return {
		FormLines: [] as Array<any>,
		formMode: mode,
		keyValue: keyValue,
		dataTable: dataTable,
		primaryKey: dataTable + "_id",
		parentColumn: "",
		parentValue: "",
	};
}

export function createFormLine(column: string, value: any, typeCode: string = "S") {
	return {
		ddColumnsId: "new123",
		columnName: column,
		value: value,
		typeCode: typeCode,
		isDirty: true,
		useEventLog: false,
	};
}

export function guidGenerator(): string {
	const S4 = function () {
		return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
	};
	return S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4();
}
